import { makeStyles } from '@material-ui/core/styles';

export default makeStyles((theme) => ({
  root: {
    width: '100%',
    justifyContent: 'center',
    height: '100%',
    // display:'flex'
  },
}));
